"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const adminClient_1 = require("client/adminClient");
const HelperUtils_1 = require("utils/HelperUtils");
const CommentBox = ({ surveyId, essayId, occurrenceId }) => {
    const [essayData, setEssayData] = (0, react_1.useState)([]);
    const [offset, setOffset] = (0, react_1.useState)(null);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const getEssay = async () => {
        const paramEssay = {
            limit: 10,
            surveyOccurrenceId: +occurrenceId,
            olderThan: offset
        };
        const { data, pagination } = await (0, adminClient_1.getEssayResult)(surveyId, essayId, paramEssay);
        if (data) {
            setEssayData(essayData.concat(data));
            setOffset(pagination.next.olderThan);
            setHasMore(pagination.next.olderThan == null ? false : true);
        }
    };
    const onScroll = (e) => {
        const target = e.target;
        const loadMore = async () => {
            await getEssay();
        };
        if (hasMore) {
            (0, HelperUtils_1.loadMoreValidator)(target, 100, () => {
                loadMore();
            });
        }
    };
    (0, react_1.useEffect)(() => {
        getEssay();
    }, []);
    return (react_1.default.createElement("div", { className: "flex items-center w-[992px] p-[16px] bg-n-200 rounded-[4px] max-h-[264px]" },
        react_1.default.createElement("div", { className: "overflow-y-scroll", onScroll: onScroll },
            react_1.default.createElement("div", { className: "grid gap-y-[8px] w-full max-h-[232px]" }, essayData?.length > 0 &&
                essayData.map(({ id, answer }) => {
                    return (react_1.default.createElement("div", { className: "flex flex-row bg-n-000", key: id },
                        react_1.default.createElement("div", { className: "flex mr-[8px]" },
                            react_1.default.createElement("p", { className: "typography-paragraph text-n-900 px-[16px] py-[4px]" }, answer))));
                })))));
};
exports.default = CommentBox;
